import React from "react"
import { Bar } from 'react-chartjs-2'

export default class BarChart extends React.Component {
  constructor(props) {
    super(props)
    this.onKeyDown = this.onKeyDown.bind(this)
    this.openTip = this.openTip.bind(this)
    this.closeTip = this.closeTip.bind(this)

    this.chartIndex = -1
    this.openTooltip = -1

    this.useTooltips = false
    if (props.options && props.options.tooltips && props.options.tooltips.enabled)
      this.useTooltips = true
  }

  openTip(myChart, datasetIndex, pointIndex) {
    if (myChart.tooltip._active == undefined)
      myChart.tooltip._active = []
    const activeElements = myChart.tooltip._active
    const requestedElem = myChart.getDatasetMeta(datasetIndex).data[pointIndex]
    for (let i = 0; i < activeElements.length; i++) {
      if (requestedElem._index == activeElements[i]._index)
       return
    }
    activeElements.push(requestedElem)
    myChart.tooltip._active = activeElements
    myChart.tooltip.update(true)
  }

  closeTip(myChart, datasetIndex, pointIndex) {
    const activeElements = myChart.tooltip._active
    if (activeElements == undefined || activeElements.length == 0) 
      return
    const requestedElem = myChart.getDatasetMeta(datasetIndex).data[pointIndex]
    for (let i = 0; i < activeElements.length; i++) {
      if (requestedElem._index == activeElements[i]._index) {
        activeElements.splice(i, 1)
        break
      }
    }
    myChart.tooltip._active = activeElements
    myChart.tooltip.update(true)
  }

  onKeyDown(val) {
    if (val.which === 9) {
      let myChart = this.chart
      let datasets = myChart.config.data.datasets.length
      let labels = myChart.config.data.labels.length

      let openDataset = this.openTooltip % datasets
      let openLabel = Math.floor(this.openTooltip / datasets)

      console.log("tabbed!", myChart)

      if (this.chartIndex < datasets * labels) {
        // do keydown function stuff
        if (val.shiftKey) {
          if (this.chartIndex < 1) {
            // focus previous element (outside of chart)
            return
          } else {
            // Close current tooltip & revert color
            this.closeTip(myChart, openDataset, openLabel)

            //myChart.data.datasets[openDataset].backgroundColor[openLabel] = this.props.data.datasets[openDataset].backgroundColor[openLabel]

            // Open previous tooltip & change color
            this.chartIndex -= 1

            let indexDataset = this.chartIndex % datasets
            let indexLabel = Math.floor(this.chartIndex / datasets)

            //myChart.data.datasets[indexDataset].backgroundColor[this.chartIndex] = modifiedBg[this.chartIndex]

            myChart.update()
            this.openTip(myChart, indexDataset, indexLabel)
            this.openTooltip = this.chartIndex

            val.preventDefault()
          }
        } else if (this.chartIndex < datasets * labels - 1) {
          // Close current tooltip & revert color
          this.closeTip(myChart, openDataset, openLabel)

          //myChart.data.datasets[openDataset].backgroundColor[this.openTooltip] = originalBg[this.openTooltip]

          // Open next tooltip & change color
          this.chartIndex += 1
          if (this.tooltipFocusOut === 0) { // jump forward 1 tooltip if tooltip 1 was already showing
            this.tooltipFocusOut = -1
            this.chartIndex += 1
          }
          let indexDataset = this.chartIndex % datasets
          let indexLabel = Math.floor(this.chartIndex / datasets)

          //myChart.data.datasets[indexDataset].backgroundColor[this.chartIndex] = modifiedBg[this.chartIndex]

          myChart.update()
          this.openTip(myChart, indexDataset, indexLabel)
          this.openTooltip = this.chartIndex
          
          val.preventDefault()
        } else {
          return
        }
      } else {
        // focus next element (outside of chart)
        return
      }
    }
  }

  render() {
    return <div tabIndex={this.useTooltips ? "0" : ""} onKeyDown={this.onKeyDown}><Bar {...this.props} ref={(ref)=>{this.chart = ref ? ref.chartInstance : this.chart}}/></div>
  }
}